"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Switch = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useFormState2 = _interopRequireDefault(require("../hooks/useFormState"));

var _core = require("@material-ui/core");

var _excluded = ["color", "dataQa"];

var Switch = function Switch(_ref) {
  var color = _ref.color,
      dataQa = _ref.dataQa,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useFormState = (0, _useFormState2["default"])(props),
      name = _useFormState.name,
      value = _useFormState.value,
      onChange = _useFormState.onChange,
      onBlur = _useFormState.onBlur,
      checked = _useFormState.checked;

  return /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-qa": dataQa,
    color: color,
    name: name,
    checked: checked,
    value: value,
    onChange: onChange,
    onBlur: onBlur
  });
};

exports.Switch = Switch;
Switch.propTypes = {
  /** The color of the component */
  color: _propTypes["default"].oneOf(['primary', 'secondary', 'default']).isRequired,

  /** QA Tag */
  dataQa: _propTypes["default"].string.isRequired,

  /** Indicates whether or not the switch is selected */
  checked: _propTypes["default"].bool,

  /** The value of the component. The DOM API casts this to a string. */
  value: _propTypes["default"].string,

  /** Callback function fired when a menu item is selected.
   Signature:
   function(event: object, child?: object) => void
   event: The event source of the callback. You can pull out the new value by accessing event.target.valu
  */
  onChange: _propTypes["default"].func.isRequired
};
Switch.defaultProps = {
  color: 'primary'
};
var _default = Switch;
exports["default"] = _default;